import { Box, Grid } from '@mui/material';
import { routes } from '../../constants';
import Button from '../../components/Button';
import * as T from '../../components/Typography';
import colors from '../../theme/colors';
import logo from '../../components/assets/file-check.svg';
import { useAuth } from '../../context/auth';
import { handleFileDownload } from '../../helpers/handle-file-download';

const CardElement = ({ title, description, buttonText, onClick }) => {
  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      alignSelf={'center'}
      alignItems={'center'}
      justifyContent={'space-between'}
      border={`1px solid ${colors.neutral.shades.shade200}`}
      borderRadius={'8px'}
      padding="24px"
      width={'100%'}
      maxWidth={'280px'}
      height={'100%'}
      mb={4}
    >
      <T.TextLargeBold
        mb="2"
        ta="center"
        color={colors.neutral.shades.shade700}
      >
        {title}
      </T.TextLargeBold>
      <T.TextSmallRegular
        ta="center"
        mb={6}
        center
        color={colors.neutral.shades.shade600}
      >
        {description}
      </T.TextSmallRegular>
      <Button variant="blue" onClick={onClick} width="200px">
        {buttonText}
      </Button>
    </Box>
  );
};

const SubmitSurveySuccess: React.FC = () => {
  const { user } = useAuth();

  const { VITE_SF_SURVEY_URL, VITE_SANDBOX_SUFFIX } = import.meta.env;
  const downloadUrl = `${VITE_SF_SURVEY_URL}/indexpdf${VITE_SANDBOX_SUFFIX ?? ''}?contactid=${user?.salesforceContactId}`;

  return (
    <Grid
      container
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid
        container
        maxWidth={'592px'}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        mt={4}
        mb={4}
      >
        <img src={logo} alt="account verified" />
        <T.H4
          mt="6"
          mb="2"
          ta="center"
          color={colors.neutral.shades.shade700}
        >
          SURVEY SUBMITTED SUCCESSFULLY!
        </T.H4>
        <T.TextSmallRegular
          ta="center"
          center
          color={colors.neutral.shades.shade600}
        >
          Your survey has been successfully submitted. Our team will review it soon, and you'll be notified of any next steps. You'll also receive payment instructions shortly via email.
        </T.TextSmallRegular>
        <Box
          display={'flex'}
          flexDirection={{ xs: 'column', md: 'row' }}
          justifyContent={{
            xs: 'center',
            md: 'space-between'
          }}
          alignContent={'center'}
          width={'100%'}
          maxWidth={'592px'}
          mt={4}
        >
          <CardElement
            title="Review your responses"
            description="View a detailed summary of your survey answers anytime."
            buttonText="Review survey"
            onClick={() =>
              window.open(
                downloadUrl,
                '_blank'
              )
            }
          />
          <CardElement
            title="Download a copy"
            description="PDF version of your completed survey for your records."
            buttonText="Download survey"
            onClick={(e: any) => {
              e.preventDefault();
              e.stopPropagation();
              handleFileDownload(downloadUrl, 'survey_completed.pdf')
            }}
          />
        </Box>
        <Button
          variant="primary"
          onClick={() => (window.location.href = routes.HOME)}
          width="200px"
          mt={4}
        >
          Return to portal
        </Button>
      </Grid>
    </Grid>
  );
};

export default SubmitSurveySuccess;
